import React from 'react';
import { createRoot }  from 'react-dom/client';
import App from './components/App';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'notosans-fontface/css/notosans-fontface.min.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';

import './stylesheets/index.scss';

import storeProvider from './store/storeProvider';

const store = storeProvider.configureStore();

const root = createRoot(document.getElementById('root'));
root.render(<App store={store} />);
